// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { customerAddressFormStyles } from "@insite/content-library/Components/CustomerAddressForm";
import { fontConfig } from "@vanmeter/XDL/constants";
import { modalButtonsActionStyles } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

customerAddressFormStyles.formButtonsWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        margin-top: 16px;
    `,
};

customerAddressFormStyles.cancelButton = {
    ...modalButtonsActionStyles.cancelButton,
    sizeVariant: "small",
    typographyProps: { lineHeight: fontConfig.smallSingleLine.lineHeight },
};

customerAddressFormStyles.submitButton = {
    ...modalButtonsActionStyles.submitButton,
    sizeVariant: "small",
    typographyProps: { lineHeight: fontConfig.smallSingleLine.lineHeight },
};
